import React from "react";
import SelectPayMethod from "./SelectPayMethod";

const RadioButtonPayMethod = (props) => {
    const { data, guardarCampoCuenta, seleccionarCombo } = props;
    const { Validaciones, ValidarPantalla } = data;

    const radioFormaPagos = data.GET_FORMA_PAGO.map((formaPago, index) => {
        const estaSeleccionado = (formaPago.Id == data.Cuenta.FormaPagoId);

        return (
            <div className="col-xs-4" key={"forma-pago-" + index} >
                <div className="container-radio radio-margin">
                    <input type="radio" name="forma-pago" value={formaPago.Id} id={"forma-pago-radio-" + index}
                        checked={estaSeleccionado} data-debitocuenta={formaPago.EsDebitoEnCuenta} data-codigo={formaPago.Codigo}
                        onChange={(event) => {
                            guardarCampoCuenta(event.target.value, "FormaPagoId", (event.target.dataset.debitocuenta == "true"), event.target.dataset.codigo)
                        }} />
                    <label className="lbl-radio label-secondary" htmlFor={"forma-pago-radio-" + index}>{formaPago.Descripcion}</label>
                </div>
            </div>
        );
    });

    let mensajeError = null
    if (ValidarPantalla == true) {
        if (Validaciones.FormaPagoSeleccionada == false) {
            mensajeError = <label className="error">Debe seleccionar una forma de pago</label>;
        }
    }

    return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary"> Forma de pago </label>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    {radioFormaPagos}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    {mensajeError}
                </div>
            </div>
            <div>
                {data.Cuenta.EsDebitoEnCuenta == true &&
                    <SelectPayMethod data={data} seleccionarCombo={seleccionarCombo} />}
            </div>
        </div>
    );
}

export default RadioButtonPayMethod;